import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { isOnIndustryStepAndCredentialVerifiedNewUser } from '../google-authentication/google-prompt/googlePromptUtils';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { getIsOAuthExistingUser, getIsVerifiedByGoogleCredential } from '../store/app/selectors';
import { getPreviousStep } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { StepSubtitle } from './StepSubtitle';
export const GreetingsPretitle = () => {
  const {
    data: firstName
  } = useSignupData(Data.FirstName);
  const {
    data: lastName
  } = useSignupData(Data.LastName);
  const previousStep = useSelector(getPreviousStep);
  const locale = getApplicationLocale();
  const isJapanese = locale === Locale.ja;
  const {
    currentStep
  } = useCurrentStep();
  const isGoogleCredentialAuthentication = useSelector(getIsVerifiedByGoogleCredential);
  const isExistingOAuthUser = useSelector(getIsOAuthExistingUser);
  const hasSelectedOAuthSignup = useSelector(isOAuthSignup);
  const hasJustSubmittedName = previousStep === Step.Name || previousStep === Step.LandingPage && hasSelectedOAuthSignup;

  const renderNiceToMeetYouSubtitle = () => {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.nice-to-meet-you`,
      messageOptions: {
        name: isJapanese ? lastName : firstName
      }
    });
  };

  if (isOnIndustryStepAndCredentialVerifiedNewUser(currentStep, isGoogleCredentialAuthentication, isExistingOAuthUser)) {
    return renderNiceToMeetYouSubtitle();
  }

  if (hasJustSubmittedName) {
    return renderNiceToMeetYouSubtitle();
  }

  if (previousStep === Step.ExistingAccounts) {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.hi`,
      messageOptions: {
        name: isJapanese ? lastName : firstName
      }
    });
  }

  return null;
};